$(document).ready(() => {
  const sections = document.getElementById('product-grid').dataset.id;
  const FILTER_TAG_PREFIXES = ['team-', 'style-', 'color-'];
  const section = sections[0];
  const customCache = {};

  function addToCache(urlPathKey, html) {
    if (customCache[urlPathKey]) {
      return;
    }

    customCache[urlPathKey] = html;
  }

  const originWindowPathName = `${window.location.pathname}`;  

  function handleTeamCheckboxClick() {
    const prevUrl = new URL(window.location.href);
    const tagToRemove = this.id.replace(" ", "-").replace("-1", "").toLowerCase();
    const pathName = window.location.pathname;
    const pathSegments = pathName.split('/');
    const lastPathSegment = pathSegments.pop();

    $(this).removeClass('checked-checkbox').addClass('unchecked-checkbox');

    // check if last segment contains filter tag(s)
    const lastSegmentContainsFilterTags = FILTER_TAG_PREFIXES.some((tagPrefix) => lastPathSegment.includes(tagPrefix));

    let prevFilterTags = [];
    let newPath = window.location.pathname;

    if (lastSegmentContainsFilterTags) {
      prevFilterTags = lastPathSegment.split('+').filter((tag) => tag !== '');
      newPath = pathSegments.join('/');
    }

    const updatedTags = prevFilterTags.filter((tag) => tag !== tagToRemove);
    const updatedTagsSegmentString = updatedTags.join('+');

    newPath += `/${updatedTagsSegmentString}${prevUrl.search}`
    updateURLHash(newPath);

    const urlToFetch = prevUrl.search ? `${newPath}&section_id=collection-template` : `${newPath}?section_id=collection-template`;

    fetch(urlToFetch)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;

        document.getElementById('product-grid').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid').innerHTML;
        // addToCache(newPath, html);
      });
  };
  
  function handleTeamInactiveCheckboxesClick() {
    const prevUrl = new URL(window.location.href);
    const newTag = this.id.replace(" ", "-").replace("-1", "").toLowerCase();
    const pathName = window.location.pathname;
    const pathSegments = pathName.split('/');
    const lastPathSegment = pathSegments.pop();

    $(this).removeClass('unchecked-checkbox').addClass('checked-checkbox');

    // check if last segment contains filter tag(s)
    const lastSegmentContainsFilterTags = FILTER_TAG_PREFIXES.some((tagPrefix) => lastPathSegment.includes(tagPrefix));

    let prevFilterTags = [];
    let newPath = window.location.pathname;

    if (lastSegmentContainsFilterTags) {
      prevFilterTags = lastPathSegment.split('+').filter((tag) => tag !== '');
      newPath = pathSegments.join('/');
    }

    let updatedTags = [...prevFilterTags];

    const prevQueryIncludesNewTag = prevFilterTags.findIndex((tag) => tag === newTag) !== -1;

    if (!prevQueryIncludesNewTag) {
      updatedTags.push(newTag);
    }

    const updatedTagsSegmentString = updatedTags.join('+');
    newPath += `${newPath.endsWith('/') ? '' : '/'}${updatedTagsSegmentString}${prevUrl.search}`

    updateURLHash(newPath);

    const urlToFetch = prevUrl.search ? `${newPath}&section_id=collection-template` : `${newPath}?section_id=collection-template`;

    if (customCache[newPath]) {
      document.getElementById('product-grid').innerHTML = new DOMParser().parseFromString(customCache[newPath], 'text/html').getElementById('product-grid').innerHTML;

      return;
    }
    
    fetch(urlToFetch)
      .then(response => response.text())
      .then((responseText) => {
        console.log({ responseText });
        const html = responseText;
        console.log({ html });

        document.getElementById('product-grid').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid').innerHTML;
        // addToCache(newPath, html);
      });
  };

  function handleSortOptionClick() {
    const activeSortOption = $(this)[0].dataset.id;

    $('.filter-sorting-option').removeClass('active-sort-filter');
    $(this).addClass('active-sort-filter');

    if (activeSortOption) {
      let url = new URL(window.location.href);
      url.searchParams.set('sort_by', activeSortOption);

      updateURLHash(`${url.pathname}${url.search}`);

      fetch(`${url.pathname}${url.search}`)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
  
          document.getElementById('product-grid').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid').innerHTML;

          // addToCache(`${url.pathname}${url.search}`, html);
        });
    }
  };

  const onHistoryChange = (event) => {
    const pathName = event.state ? event.state.pathName : window.location.search.slice(1);

    fetch(pathName)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;

        document.getElementById('product-grid').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid').innerHTML;
      });
  };

  function updateURLHash(newPath, queryParams) {
    let newUrl = newPath;
    if (queryParams) {
      newUrl += `&${queryParams}`;
    }
    
    history.pushState({ pathName: newUrl }, '', newUrl);
  }

  $('#teams-fiter').on("click", ".checked-checkbox", handleTeamCheckboxClick);
  $('#teams-fiter').on("click", ".unchecked-checkbox", handleTeamInactiveCheckboxesClick);

  $('#styles-fiter').on("click", ".checked-checkbox", handleTeamCheckboxClick);
  $('#styles-fiter').on("click", ".unchecked-checkbox", handleTeamInactiveCheckboxesClick);

  $('#colors-fiter').on("click", ".checked-checkbox", handleTeamCheckboxClick);
  $('#colors-fiter').on("click", ".unchecked-checkbox", handleTeamInactiveCheckboxesClick);

  $('.filter-sorting-option').on("click", handleSortOptionClick);

  window.addEventListener('popstate', onHistoryChange);
});

